import React, { FunctionComponent } from 'react';
import moment from 'moment';
import { Box, Typography, Card, CardContent, makeStyles } from '@material-ui/core';
import { MergeQueueHistory } from '../../../store/modules/calendar/types';
import TableEmptyState from '../../../components/TableView/TableEmptyState';
import InfiniteScrollTableView from '../../../components/InfiniteScrollTableView';
import { DropDownField } from 'src/store/modules/application/types';

type PrintDocumentsHistoryList = {
    printDocumentsHistoryList: MergeQueueHistory[];
    skip: number;
    setSkip: Function;
    hasMore: boolean;
    documentCount: number;
    mergeDocuments: Function;
    selectedTemplate: DropDownField;
};
interface IColumn {
    id: 'noticeType|string' | 'printDate|string';

    label: string;
    maxWidth?: number;
    align?: 'right' | 'left' | 'center';
    format?: (value: string) => string;
    field: string;
    noSort?: boolean;
}
const columns: IColumn[] = [
    {
        id: 'noticeType|string',
        label: 'Notice Type',
        align: 'left',
        maxWidth: 300,
        field: 'noticeType',
        noSort: true,
    },
    {
        id: 'printDate|string',
        label: 'Print Date',
        align: 'left',
        maxWidth: 200,
        field: 'printDate',
        noSort: true,
    },
];

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 275,
        margin: '0px 50px',
    },
    title: {
        color: '#484848',
        fontSize: 20,
        fontWeight: 500,
        letterSpacing: 0,
    },
    noticeType: {
        display: 'flex',
        margin: '8px',
        fontSize: 14,
        color: '#484848',
        fontWeight: 600,
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    headerContainer: {
        display: 'flex',
    },
    bodyContainer: {
        display: 'flex',
        margin: 100,
    },
    selectInput: {
        fontSize: 13,
        border: '1px solid rgb(0,0,0,0.23) !important',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        borderRadius: 3,
        marginBottom: '5px',
        color: '#484848 !important',
    },
    borderedInputs: {
        border: '1px solid #ced4da',
        padding: 5,
        borderRadius: 4,
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    width: {
        width: '100%',
    },
    downloadBtnContainer: {
        marginLeft: 10,
        marginTop: 5,
    },
    emptyPrintHistoryRecord: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
    },
}));

const PrintDocumentsHistoryInfiniteList: FunctionComponent<PrintDocumentsHistoryList> = (props) => {
    const classes = useStyles();

    const { printDocumentsHistoryList, hasMore, skip, setSkip, mergeDocuments, selectedTemplate } = props;

    const loadMore = () => {
        if (hasMore) {
            setSkip(skip + 1);
        }
    };

    const onClickRow = (id: string, e: any) => {
        e.stopPropagation();
    };

    const handleDownloadCase = (item: MergeQueueHistory, e: any) => {
        e.stopPropagation();
        mergeDocuments(item?.mergeTemplate?.id, item?.mergeTemplate?.name, item?.id);
        setSkip(0);
    };

    const formattedData = printDocumentsHistoryList?.map((item: MergeQueueHistory) => ({
        ...item,
        id: item?.id,
        mergeTemplate: item?.mergeTemplate,
        noticeType: item?.mergeTemplate?.name,
        printDate: moment(item?.timestamp).format('L LT'),
    }));

    return (
        <Card className={`${classes.root} verticalFillContainer`}>
            <CardContent className={classes.headerContainer}>
                <Typography className={classes.title}>Print History</Typography>
            </CardContent>
            <CardContent className="verticalFillContent">
                {formattedData?.length ? (
                    <InfiniteScrollTableView
                        columns={columns}
                        data={formattedData}
                        count={formattedData?.length}
                        onClickRow={onClickRow}
                        sortBy={'printDate'}
                        sortOrder="desc"
                        hasMore={hasMore}
                        loadMore={loadMore}
                        downloadFlag
                        handleDownloadCase={handleDownloadCase}
                        scrollToTopTrigger={selectedTemplate}
                    />
                ) : (
                    <Box className={classes.emptyPrintHistoryRecord}>
                        <TableEmptyState title="No record found" message=""></TableEmptyState>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default PrintDocumentsHistoryInfiniteList;
